/**
 * Severity styling, in one place.
 *
 * Lived on `SignalCard` when the feed was a list of cards. The card is gone
 * and three surfaces still read it — the table, the detail modal, and the
 * symbol page — so it belongs in a module none of them owns.
 */
export const SEVERITY_CLASS: Record<string, string> = {
  urgent: "border-danger",
  warn: "border-warning",
  info: "border-border",
};

/** Sorted by how much a reader should care, not alphabetically. */
export const SEVERITY_RANK: Record<string, number> = { info: 0, warn: 1, urgent: 2 };

/** Just the text, for a badge that carries its own background. */
export const SEVERITY_TEXT: Record<string, string> = {
  urgent: "text-danger",
  warn: "text-warning",
  info: "text-text-muted",
};

/**
 * The row tint for the feed table, which has to be opaque.
 *
 * `SEVERITY_CLASS` above tints with an alpha, which is right everywhere it is
 * read from — a badge or a panel sitting on one background. The feed table is
 * the exception: its first six columns are `position: sticky`, so the rest of
 * the row slides underneath them, and a 10% tint let the moving cells show
 * through the pinned ones. These two tokens are the same colours composited
 * ahead of time (`index.css`), so a pinned cell can take `bg-inherit` and land
 * on the exact shade its row already paints.
 */
export const SEVERITY_ROW_CLASS: Record<string, string> = {
  urgent: "bg-row-urgent",
  warn: "bg-row-warn",
  info: "bg-surface-raised",
};
